// edit: zhangmyh 2017-6-20 7:52 PM

function formRefer (params) {
  this.id = params.id || 'formeditor'
  this.type = params.type || 'text'
  this.displayName = params.displayName || '字段'
  this.required = params.required || false
  let tiplist = []
  if (params.tip) {
    if (typeof params.tip == 'string') {
      if (params.tip != '') {
        tiplist.push(params.tip)
      }
    } else if (typeof params.tip == 'object') {
      let tip
      if (params.tip[params.field]) {
        tip = params.tip[params.field]

        if (typeof tip == 'string') {
          if (tip != '') {
            tiplist.push(tip)
          }
        } else if (typeof tip == 'object') {
          if (tip.length > 0) {
            tiplist = tip
          }
        }
      } else if (params.tip.length > 0) {
        tiplist = params.tip
      }
    }
  }
  this.tip = tiplist
  this.hasTip = (tiplist.length > 0)
  this.model = params.model
  this.field = params.field
}

export default formRefer



// WEBPACK FOOTER //
// ./src/components/ag-form/form-date/index.js